import { gtmPush } from "src/modules/utils/helpers";

// return an array of subquestion saved answers from a question
const getAnswers = (_question) => {
    let responses = [];
    Object.keys(_question.subquestions).forEach((k) => {
        const savedAnswer = _question.subquestions[k]?.savedAnswer;
        const hasOptions = _question.subquestions[k]?.options?.length > 0;
        const savedAnswerIndex = hasOptions
            ? _question.subquestions[k]?.options.indexOf(savedAnswer) + 1
            : null;
        if (savedAnswer) {
            responses.push({
                title: _question.subquestions[k]?.title,
                questionNo: _question.id,
                questionSection: _question.subquestions[k].id,
                savedAnswer,
                savedAnswerIndex,
                value: savedAnswer,
                questionStatus: _question.status,
            });
        }
    });
    return responses;
};

// Capture all quiz answers from the complete questions object
//
// USAGE EXAMPLE:
// import { getAllQuizAnswers } from "src/modules/QuizHelpers/index.js";
// import { useQuiz } from "src/contexts/QuizContext.js";
//
// function MyComponent() {
//   const { questions } = useQuiz();
//
//   const handleCaptureAnswers = () => {
//     const allAnswers = getAllQuizAnswers(questions);
//     console.log("Captured answers:", allAnswers);
//
//     // Send to API, analytics, or store as needed
//     // fetch('/api/quiz-answers', {
//     //   method: 'POST',
//     //   body: JSON.stringify(allAnswers)
//     // });
//   };
//
//   return <button onClick={handleCaptureAnswers}>Capture Answers</button>;
// }
//
const getAllQuizAnswers = (questions) => {
    const allAnswers = Object.keys(questions)
        .map((questionKey) => {
            const question = questions[questionKey];
            return {
                questionId: question.id,
                questionTitle: question.title,
                questionStatus: question.status,
                answers: Object.keys(question.subquestions)
                    .map((sectionKey) => {
                        const section = question.subquestions[sectionKey];
                        return {
                            sectionId: section.id,
                            sectionTitle: section.title,
                            answer: section.savedAnswer,
                            score: section.score,
                        };
                    })
                    .filter((section) => section.answer), // Only include answered sections
            };
        })
        .filter((question) => question.answers.length > 0); // Only include questions with answers

    return allAnswers;
};

/**
 * Quiz Interaction Tracking Helper
 */
export const quizInteractionTracking = ({
    interaction_type,
    question_number = null,
    sub_question_index = null,
    selected_answer_index = null,
    answer_changed = false,
    navigation_action = null,
}) => {
    gtmPush({
        event: "quiz_interaction",
        interaction_type,
        question_number,
        sub_question_index,
        selected_answer_index,
        answer_changed,
        navigation_action,
    });
};

export { getAnswers, getAllQuizAnswers };
